module.exports = __webpack_public_path__ + "img/header-11.37716e69.png";